import React from 'react';
import Button from '../../../components/ui/Button';

const FormActions = ({ onSaveDraft, onCreateProject, onCancel, isSubmitting }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex flex-col sm:flex-row items-center justify-end gap-4">
        <Button
          variant="ghost"
          onClick={onCancel}
          disabled={isSubmitting}
          className="w-full sm:w-auto"
        >
          Cancel
        </Button>

        <Button
          variant="outline"
          onClick={onSaveDraft}
          disabled={isSubmitting}
          iconName="Save"
          iconPosition="left"
          className="w-full sm:w-auto"
        >
          Save Draft
        </Button>

        <Button
          variant="default"
          onClick={onCreateProject}
          loading={isSubmitting}
          iconName="Plus"
          iconPosition="left"
          className="w-full sm:w-auto"
        >
          Create Project
        </Button>
      </div>
    </div>
  );
};

export default FormActions;